<template>
    <div style="position: relative">
        <span class="flex w-full mt-4"> 
            <slot name="actions" />
            <div style="flex: 1; align-self: center;" class="ml-2 underline">
                <strong>
                    {{ order.quantity > 1 ? `${order.quantity}x` : '' }}
                    {{ order.product.description.toUpperCase() }}
                </strong>
                ({{ order.value || 0 | currency }})
            </div>
        </span>

        <div class="vx-row w-full ml-4" v-for="(option, o) in Object.entries(order.options)" :key="o">
            <span class="ml-8 font-semibold">{{ option[1].description }}</span>
            <span class="w-full ml-12" v-for="(item, b) in Object.entries(option[1].items)" :key="b">
                {{ option[1].type == 'multiple' ? `${item[1].selected}x` : '' }}
                {{ item[1].description }}
                {{ item[1].value ? '(' + item[1].value.toFixed(2).replace('.', ',') + ')' : '' }}
            </span>
        </div>

        <div class="vx-row w-full">
            <span class="w-full pl-8 mt-2" style="text-decoration: underline" v-if="order.obs"> {{ $t('observation').toUpperCase() }}: {{ order.obs }} </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            order: {
                type: Object,
                required: true
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>